interface IpInfoResponse {
    country?: string;
    error?: string;
}

const COUNTRY_TO_CURRENCY: Record<string, string> = {
    // Switzerland
    'CH': 'CHF',
    // Eurozone countries
    'DE': 'EUR',
    'FR': 'EUR',
    'IT': 'EUR',
    'GB': 'EUR',
    'AT': 'EUR',
    'BE': 'EUR',
    'NL': 'EUR',
    'LU': 'EUR',
    'ES': 'EUR',
    'PT': 'EUR',
    'IE': 'EUR',
    'FI': 'EUR',
    'GR': 'EUR',
    'CY': 'EUR',
    'MT': 'EUR',
    'SI': 'EUR',
    'SK': 'EUR',
    'EE': 'EUR',
    'LV': 'EUR',
    'LT': 'EUR',
};

export async function getCountry(): Promise<string> {
    try {
        const res = await fetch('https://ipinfo.io/json?token=a0b6ac6bab5d5f');

        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }

        const data: IpInfoResponse = await res.json();

        if (data.error) {
            throw new Error(data.error);
        }

        return data.country || 'XX';
    } catch (error) {
        console.error('Failed to detect country:', error);
        return 'XX';
    }
}

export function getCurrencyFromCountry(country: string): string {
    return COUNTRY_TO_CURRENCY[country] || 'EUR';
}

export async function detectCurrency(): Promise<string> {
    const country = await getCountry();
    return getCurrencyFromCountry(country);
}
